module.exports = __webpack_public_path__ + "static/media/playlist.cef7f618.svg";